import { render } from "./UserCarrinho.vue?vue&type=template&id=66c06b9a&scoped=true"
import script from "./UserCarrinho.vue?vue&type=script&lang=js"
export * from "./UserCarrinho.vue?vue&type=script&lang=js"

import "./UserCarrinho.vue?vue&type=style&index=0&id=66c06b9a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c06b9a"]])

export default __exports__